import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'pine' | 'rust' | 'neutral';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'pine',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  return <div className={`${alignment} ${className}`} data-id="element-197" data-mp="gjgjmvaa1en2">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-198" data-mp="giwzd7x5me5v">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[2.1rem] font-bold uppercase leading-[1.04] text-pine sm:text-5xl ${eyebrow ? 'mt-5' : ''}`} data-id="element-199" data-mp="1v3og0j0jztm">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed text-ink-muted sm:text-lg ${align === 'center' ? 'mx-auto max-w-prose' : 'max-w-prose'}`} style={{
      fontSize: "14px"
    }} data-id="element-200" data-mp="6rak90hp3uxu">
          {lead}
        </p> : null}
    </div>;
}